import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Apenas configura os callbacks do Turnstile
    window.turnstileCompleted = () => {
      // Turnstile completado com sucesso
    }
    
    window.turnstileExpired = () => {
      // Turnstile expirou
    }
    
    window.turnstileError = () => {
      // Erro no Turnstile
    }
  }

  disconnect() {
    delete window.turnstileCompleted
    delete window.turnstileExpired
    delete window.turnstileError
  }
}